import { Box, BoxProps } from '@mui/material';

export const Space = ({ sx, ...wrapperProps }: BoxProps) => (
  <Box
    {...wrapperProps}
    component="span"
    sx={{ mx: 1, ...sx }}
  />
);
